module.exports = __webpack_public_path__ + "static/media/saver3.15ba4cf0.jpg";